
import Link from "next/link";
import React from "react";


const Breadcrumbs = ({ context, index, textcolor }) => {
  return context.showBc && index === 0 && <div className={`w-full max-w-375 mx-auto fil-text pt-7 mb-7 text-breadcrumbs ${textcolor}`}>
    {
      context.bc.map((item, i) => {
        return <React.Fragment key={i}>
          <Link href={item.url} className="no-underline"> {item.name} </Link>{'>'}
        </React.Fragment>
      })
    }
    <span className=""> {context.pageName} </span>
  </div>

}

export default Breadcrumbs